import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1.29335458,12.6609523 C0.882315976,12.2504496 0.906376448,11.5772824 1.34567328,11.1971725 C5.32667299,7.75253716 8.82065498,6 11.8754175,6 C14.9232999,6 18.4931513,7.746526 22.6382952,11.1835928 C23.0919101,11.5597208 23.1235937,12.2445476 22.7066454,12.6609523 C19.1652107,16.1977703 15.5940456,18 12,18 C8.40595436,18 4.83478932,16.1977703 1.29335458,12.6609523 Z M3.49527092,12.0022518 C6.41269138,14.6848339 9.24583737,16 12,16 C14.7488241,16 17.5763256,14.6899275 20.487765,12.0178358 C17.0544944,9.32461683 14.1697473,8 11.8754175,8 C9.58849508,8 6.78261255,9.31827775 3.49527092,12.0022518 Z M12,15 C13.6568542,15 15,13.6568542 15,12 C15,10.3431458 13.6568542,9 12,9 C10.3431458,9 9,10.3431458 9,12 C9,13.6568542 10.3431458,15 12,15 z"
  }));
});
var StatusUnfollow = AbstractIcon.withComponent(Icon);
StatusUnfollow.displayName = 'StatusUnfollow';
export default StatusUnfollow;